import React from 'react';
import {
  MapPin, Package, Globe, Handshake, Compass, ShoppingCart, Truck,
  LineChart, ClipboardCheck, FileText, ShieldCheck, Boxes, Search, Users,
} from 'lucide-react';

const MAP = {
  'map-pin': MapPin,
  package: Package,
  globe: Globe,
  handshake: Handshake,
  compass: Compass,
  'shopping-cart': ShoppingCart,
  truck: Truck,
  'line-chart': LineChart,
  'clipboard-check': ClipboardCheck,
  'file-text': FileText,
  'shield-check': ShieldCheck,
  boxes: Boxes,
  search: Search,
  users: Users,
};

export const Icon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Package;
  return <Cmp {...props} />;
};
